/**************************************************
 * Nombre:       Formulario_Estadisticas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {BorderColor, FilterAltOutlined, Looks3Outlined, Redo, Title, Undo} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoTextoLista from "../../../Modulo_formularios/Componentes/IngresoTextoLista";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Indicadores from "./Formulario_Indicadores";
import Tarjeta_Indicador from "../../Tarjetas/Tarjeta_Indicador";
import Formulario_Pasos from "./Formulario_Pasos";
import Tarjeta_Paso from "../../Tarjetas/Tarjeta_Paso";
import Formulario_Pregunta from "./Formulario_Pregunta";
import Tarjeta_Pregunta from "../../Tarjetas/Tarjeta_Pregunta";

const Formulario_Estadisticas = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        Tarjeta: Tarjeta_Indicador,
        Formulario: Formulario_Indicadores,
        nombre: 'Agregar Indicador',
        dato: 'indicadores'
    });
    const {IngresarObjeto: IngresoPaso} = useIngresarObjeto({
        props: props,
        Tarjeta: Tarjeta_Paso,
        Formulario: Formulario_Pasos,
        nombre: 'Agregar Paso',
        dato: 'pasos'
    });
    const {IngresarObjeto: IngresoPreguntas} = useIngresarObjeto({
        props: props,
        Tarjeta: Tarjeta_Pregunta,
        Formulario: Formulario_Pregunta,
        nombre: 'Agregar Pregunta',
        dato: 'preguntas'
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Looks3Outlined} nombre={'Titulo de Indicadores'} {...props}
                                  dato={'tituloIndicadores'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={FilterAltOutlined} nombre={'Titulo Resaltado'} {...props}
                                  dato={'rosadotituloIndicadores'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Indicadores</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Undo} nombre={'Titulo Tarjeta Antes'} {...props}
                                  dato={'tituloAntes'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoLista {...props} dato={'listaAntes'} nombre={'Lista Antes'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Redo} nombre={'Titulo Tarjeta Despues'} {...props}
                                  dato={'tituloDespues'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoLista {...props} dato={'listaDespues'} nombre={'Lista Despues'}/>
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Estadisticas